import { useRef, useState } from 'react';
import { useAuthStore } from '../../store/authStore';
import { selectIsWished, useWishlistStore } from '../../store/wishlistStore';
import NotifyMeForm from './NotifyMeForm';
import './NotifyMe.css';

interface Props {
  readonly itemId: string;
  readonly name: string;
  readonly className: string;
}

/**
 * The sold-out action. Signed in, it puts the item on the wishlist, which is the
 * account's alert list. A guest leaves an email in a dialog instead.
 */
export default function NotifyMeButton({ itemId, name, className }: Props) {
  const auth = useAuthStore((s) => s.status);
  const wished = useWishlistStore(selectIsWished(itemId));
  const toggle = useWishlistStore((s) => s.toggle);
  const dialog = useRef<HTMLDialogElement>(null);
  const [open, setOpen] = useState(false);

  if (auth === 'authed') {
    return wished ? (
      <p className="notify-me__sent" role="status">
        We&apos;ll email you when it&apos;s back.
      </p>
    ) : (
      <button type="button" className={className} onClick={() => void toggle(itemId)}>
        Notify me
      </button>
    );
  }
  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => {
          setOpen(true);
          dialog.current?.showModal();
        }}
      >
        Notify me
      </button>
      <dialog
        ref={dialog}
        className="notify-me__dialog"
        aria-label={`Email me when ${name} is back`}
        onClose={() => setOpen(false)}
      >
        <h2 className="notify-me__title">{name} is sold out</h2>
        {/* Mounted only while open, so each opening starts a fresh form. */}
        {open && <NotifyMeForm itemIds={[itemId]} intro="We'll email you once when it's back in stock." />}
        <button type="button" className="notify-me__close" onClick={() => dialog.current?.close()}>
          Close
        </button>
      </dialog>
    </>
  );
}
